import React from 'react';

const InteractivityContext = React.createContext(null);

export default InteractivityContext;
